import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import Slider from "react-slick";
import Loading from "../Loading/Loading";
import BaseURL from "../Utilities/BaseUrl";
export default function CategorySlider() {
  const [categ, setcateg] = useState([]);
  async function getCategories() {
    let { data } = await axios.get(`${BaseURL}categories`);
  
    setcateg(data.data);
  }

  useEffect(() => {
    getCategories();
  }, []);

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 3,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
  };
  return (
    <>
      {categ.length > 0 ? (
        <div className="container mt-5 ">
          <h2 className="pb-3">Shop Popular Categories</h2>
          <Slider {...settings} className="cursor-pointer">
            {categ.map((item, index) => {
              return (
                <Fragment key={index} >
                  <img
                    
                    src={item.image}
                    height={200}
                    className="w-100"
                  />
                 
                </Fragment>
              );
            })}
          </Slider>
        </div>
      ) : (
        <Loading/>
      )}
    </>
  );
}
